module.exports = __webpack_public_path__ + "static/team-21-6aaa3ebfbd12f9f8c092288a23be904b.jpg";